var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreyExport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.7487 9.86778C11.5904 9.8691 11.4316 9.81208 11.3056 9.68813C11.0619 9.44848 11.0586 9.04849 11.2982 8.80482L18.0744 1.91487C18.3141 1.6712 18.7141 1.66787 18.9577 1.90752C19.2014 2.14716 19.2047 2.54715 18.9651 2.79082L12.1889 9.68078C12.0649 9.80681 11.9071 9.86646 11.7487 9.86778Z",
    fill: "#9186A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.2193 6.30557C18.8777 6.30841 18.592 6.02745 18.5891 5.68579L18.561 2.31091L15.1862 2.33899C14.8445 2.34184 14.5588 2.06087 14.556 1.71922C14.5531 1.37756 14.8341 1.09188 15.1758 1.08904L19.1756 1.05575C19.5173 1.05291 19.803 1.33388 19.8058 1.67553L19.8391 5.67539C19.8419 6.01705 19.561 6.30273 19.2193 6.30557Z",
    fill: "#9186A1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4918 19.0204L8.49196 19.062C3.96712 19.0997 2.01776 17.1825 1.98011 12.6576L1.93851 7.65782C1.90085 3.13297 3.81803 1.18362 8.34288 1.14597L10.0095 1.1321C10.3511 1.12926 10.6368 1.41022 10.6397 1.75188C10.6425 2.09353 10.3615 2.37921 10.0199 2.38205L8.35328 2.39592C4.51174 2.42789 3.1565 3.80588 3.18846 7.64742L3.23007 12.6472C3.26203 16.4888 4.64003 17.844 8.48156 17.8121L13.4814 17.7705C17.3229 17.7385 18.6782 16.3605 18.6462 12.519L18.6323 10.8524C18.6295 10.5107 18.9105 10.225 19.2521 10.2222C19.5938 10.2193 19.8794 10.5003 19.8823 10.8419L19.8962 12.5086C19.9338 17.0334 18.0166 18.9828 13.4918 19.0204Z",
    fill: "#9186A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreyExport);
export default __webpack_public_path__ + "static/media/greyExport.f2c9ec0a6a9aa814764e9d3089ca6c3d.svg";
export { ForwardRef as ReactComponent };